<template>
  <div class="sms-btn">
    <Button
      v-if="shape"
      :shape="shape"
      @click="getCodeEvent"
      :style="{ height: height }"
      >{{ text }}</Button
    >
    <Button
      v-else
      @click="getCodeEvent"
      :style="{ height: height }"
      >{{ text }}</Button
    >
  </div>
</template>
<script>
export default {
  name: "smsButton",
  props: {
    shape: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "auto",
    },
  },
  data() {
    return {
      text: "获取验证码",
    };
  },
  methods: {
    async getCodeEvent() {
      if (this.tap) return false;
      this.tap = true;
      await this.$emit("tap", (res) => {
        if (res) {
          let i = 60;
          this.text = `${i--}秒后再获取`;
          this.getCodeInterval = setInterval(() => {
            if (i <= 1) {
              this.text = "获取验证码";
              this.tap = false;
              clearInterval(this.getCodeInterval);
              return;
            }
            this.text = `${i--}秒后再获取`;
          }, 1000);
        }
      });
    },
    reset() {
      this.text = "获取验证码";
      this.tap = false;
      this.getCodeInterval && clearInterval(this.getCodeInterval);
    },
  },
  beforeDestroy() {
    this.getCodeInterval && clearInterval(this.getCodeInterval);
  },
};
</script>
<style lang="less" scoped>
.sms-btn /deep/ {
  .ivu-btn {
    width: 100%;
    height: 100%;
    background-color: #F85A36;
    color: #fff;
    &:hover{
      border-color: #F85A36;
    }
  }
}
</style>
